export default {
  'component.stylingfinish.title': 'Styling',
  'component.stylingfinish.heading1': 'Takk for ordren!',
  'component.stylingfinish.heading1.decsription':
    'Stylisten vil nå kontakte deg for å avtale ytterligere detaljer. Klikk på OK for å gå tilbake til hovedsiden.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. På vero eos et accusam og justo duo',
  'component.stylingfinish.okay': 'Greit',
  'component.stylingfinish.viewdetails': 'Vis detaljer',
};
